
// SVG Icon: location
export default { id: "terriajs-location" };
export const id = "terriajs-location";
export const name = "location";
